module.exports = __webpack_public_path__ + "img/brlxzj.ffbaf60f.png";